(function () {
  'use strict';

  var LABEL = 'Comprar ya';
  var TITLE = 'Comprar ya. Te llevamos directo al pago.';
  var pending = false;

  function isExcluded(form) {
    return !!form.closest('#side-cart, .side-cart, [data-cart-upsell], .cart-upsell, #CartDrawer');
  }

  function build(form) {
    if (form.dataset.ocBuynowCard) return;
    var atc = form.querySelector('button[type="submit"].overlay-buy_button');
    if (!atc) return;
    if (isExcluded(form)) return;

    form.dataset.ocBuynowCard = '1';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oc-buynow-card';
    btn.textContent = LABEL;
    btn.title = TITLE;
    btn.setAttribute('aria-label', TITLE);

    var err = document.createElement('span');
    err.className = 'oc-buynow-card__err';
    err.setAttribute('role', 'alert');
    err.hidden = true;

    var anchor = atc.parentNode;
    anchor.insertBefore(btn, atc.nextSibling);
    anchor.insertBefore(err, btn.nextSibling);

    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      err.hidden = true;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Un momento…';
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          // OrbitaClick 16-10-2026: si el pedido no llega a 20 € (envío gratis), al carrito
          // para que vea la barra "te faltan X €" y los complementos; si llega, directo al pago.
          return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) {
              var bajoUmbral = cart && typeof cart.total_price === 'number' && cart.total_price < 2000;
              window.location.assign(bajoUmbral ? '/cart' : '/checkout');
            })
            .catch(function () { window.location.assign('/checkout'); });
        })
        .catch(function (e) {
          btn.disabled = false;
          btn.textContent = original;
          err.hidden = false;
          err.textContent = (e && (e.description || e.message))
            ? (e.description || e.message)
            : 'No hemos podido continuar. Inténtalo de nuevo o usa «Añadir a la cesta».';
        });
    });
  }

  function scan() {
    var forms = document.querySelectorAll('form.form-card');
    for (var i = 0; i < forms.length; i++) build(forms[i]);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      pending = false;
      scan();
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
